import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const updateSelectedStation = (
  state: StationsState,
  action: PayloadAction<StationsState['selectedStation']['data']>
) => {
  state.selectedStation.data = action.payload
};
